import React from "react";
import { formatCurrency } from "utils/number";

interface AuthorizationTextProps {
  bankAccountNumber: string;
  amount: number | string;
  processingDate: React.ReactNode;
}

const AuthorizationText = ({
  bankAccountNumber,
  amount,
  processingDate,
}: AuthorizationTextProps) => {
  return (
    <>
      <p className="summary-body">
        By clicking submit, you authorize Icon Financial Services, LLC (“Icon”),
        acting as Originating Depository Financial Institution via Cross River
        Bank (ODFI), to initiate ACH debit and credit entries to your Company’s
        designated bank account, and to make correcting or adjusting entries, if
        necessary.
      </p>

      <p className="summary-body">
        You represent that you are the authorized holder of the account provided
        and authorize Icon to verify the account information using commercially
        reasonable methods. You further authorize Icon to debit your account
        ending in {bankAccountNumber} the amount of {formatCurrency(amount)} on{" "}
        {processingDate}. If the processing date falls on a weekend, US federal
        holidays, or after 5:00 PM Eastern, requests will be processed on the
        next business day.
      </p>

      <p className="summary-body">
        You agree that ACH transactions initiated under this authorization will
        comply with NACHA Rules and applicable U.S. laws and acknowledge that
        this is a business-to-business authorization not subject to consumer
        protections. If you believe there is an error or must revoke
        authorization you must provide a written request to
        support@iconsavingsplan.com within two (2) business days.
      </p>
    </>
  );
};

export default AuthorizationText;
